module.exports = __webpack_public_path__ + "img/lADPD3lGsT38CN3NArzNB4A_1920_700.dd95d46f.jpg";